export default function(name, data){
    if(typeof window === 'undefined'){
        return
    }

    let e = false;
    if(window.CustomEvent){
        e = new CustomEvent(name, {detail: data})
    }else{
        e = document.createEvent('CustomEvent');
        e.initCustomEvent(name, false, false, {detail: data});
    }
   
    if(e){
        document.dispatchEvent(e);
    }   
}